<template>
	<app-section class="flex flex-col" :class="$attrs.class">
		<app-title title="Payment" class="small" />
		<app-line />
		<div class="flex items-center mb-1">
			<div class="flex flex-1">Subtotal</div>
			<div class="flex flex-1">{{ order['items'].length }} items</div>
			<div class="flex px-1">
				{{
					$filters.formatCurrency(
						order['totalNet'] + order['discountValue'] + (order['deliveryDiscount']?.discountValue || 0),
						order['currency']
					)
				}}
			</div>
		</div>
		<div v-if="order['serviceFee']" class="flex items-center mb-1">
			<div class="flex flex-1">Service Fee</div>
			<div class="flex px-1">
				{{ $filters.formatCurrency(order['serviceFee'], order['currency']) }}
			</div>
		</div>
		<div class="flex items-center mb-1">
			<div class="flex flex-1">Shipping</div>
			<div class="flex flex-1">Zone {{ order['zonenumber'] }}</div>
			<div class="flex px-1">
				<app-tooltip
					v-if="
						order['deliveryDiscount'] &&
							order['deliveryDiscount'].id !== 0 &&
							order['deliveryDiscount'].discountValue
					"
					text="This user has a discount on transport cost"
					bg-color="info"
				>
					<span class="strikethrough-diagonal">{{
						$filters.formatCurrency(order.transportCost, order['currency'])
					}}</span>
				</app-tooltip>
				<span>{{ $filters.formatCurrency(getShippingValue, order['currency']) }}</span>
			</div>
		</div>
		<div class="flex items-center mb-1" v-if="order['discountValue']">
			<div class="flex flex-1 text-primary">Discount</div>
			<div class="flex px-1 text-primary border-1 border-dashed">
				- {{ $filters.formatCurrency(order['discountValue'], order['currency']) }}
			</div>
		</div>
		<app-line />
		<div class="flex items-center mb-1">
			<div class="flex flex-1">
				<span class="font-semibold mr-2">Paid by customer</span>
				<div v-if="order['paymentMethod']" class="flex items-center text-secondary border-l-1">
					<app-tooltip text="Credit Card" v-if="order['paymentMethod'].paymentType === 'CREDIT_CARD'">
						<img class="flex px-2 h-4" alt="credit-card" src="../../../assets/images/credit-card.svg" />
					</app-tooltip>
					<div v-else class="flex px-2 font-bold">{{ order['paymentMethod'].paymentType }}</div>
				</div>
			</div>
			<div class="flex px-1 font-bold">{{ $filters.formatCurrency(order['total'], order['currency']) }}</div>
		</div>
	</app-section>
</template>

<script>
	import AppTooltip from '@/components/app/AppTooltip.vue';

	export default {
		name: 'OrdersPayment',
		components: { AppTooltip },
		props: {
			order: {
				required: true,
				type: Object,
			},
		},
		computed: {
			getShippingValue() {
				return this.order['deliveryDiscount'] && this.order['deliveryDiscount']?.id !== 0
					? this.order.transportCost - this.order['deliveryDiscount']?.discountValue
					: this.order.transportCost;
			},
		},
	};
</script>
